$(document).ready(function(){
    $(document).on("click", ".block-item-title", function(){
        if($(this).hasClass("open")) {
            $(this).removeClass("open");
            $(this).next(".block-item-content").slideToggle();
        } else {
            $(this).closest(".faq-block-contents").find(".block-item-title.open").next(".block-item-content").slideToggle();
            $(this).closest(".faq-block-contents").find(".block-item-title.open").removeClass("open");
            $(this).addClass("open");
            $(this).next(".block-item-content").slideToggle();
        }
    })
})